import { ProjectInfo } from '../../../project/models/project-info.model';
import { FormIdentifier } from '../../../project/models/form-identifier.model';
import { Agreement } from './agreement.model';
import { Contact } from '../../../project/models/project-contact.model';
import {ProjectForm} from '../../../project/models/form.model';
import {BoardDate} from './BoardDate';

export class ProjectAgreement {
  agreement: Agreement;
  formId: FormIdentifier;
  id: string;
  projectInfo: ProjectInfo;
  projectContacts: Contact[];
  boardDate: BoardDate;

  constructor(projectAgreement?: any) {
    projectAgreement = projectAgreement || {};
    this.agreement = projectAgreement.agreement
      ? new Agreement(projectAgreement.agreement)
      : null;
    this.formId = projectAgreement.formId
      ? new FormIdentifier(projectAgreement.formId)
      : null;
    this.id = projectAgreement.id || null;
    this.projectInfo = projectAgreement.projectInfo
      ? new ProjectInfo(projectAgreement.projectInfo)
      : null;
    this.projectContacts = projectAgreement.projectContacts
      ? projectAgreement.projectContacts
      : [];
    this.boardDate = projectAgreement.boardDate ? projectAgreement.boardDate : [];
  }
}
